(function () {

    'use strict';

    angular.module('app').config(administrationUrlConfig);

    administrationUrlConfig.$inject = ['$routeProvider', '$locationProvider'];

    function administrationUrlConfig($routeProvider, $locationProvider) {
        $routeProvider
            .when('/administration/new', {
                templateUrl: '/templates/pages/administration/administration-user-edit.html',
                controller: 'AdministrationUserController',
                controllerAs: 'vm',
                params: {
                    parent: 'administration',
                    htmlTitle: 'Administration',
                    pageTitle: 'Administration'
                }
            })
            .when('/administration/admin-accounts/:accountId', {
                templateUrl: '/templates/pages/administration/administration-user-edit.html',
                controller: 'AdministrationUserController',
                controllerAs: 'vm',
                params: {
                    parent: 'administration',
                    htmlTitle: 'Administration',
                    pageTitle: 'Administration'
                }
            })
            .when('/administration/team-actions', {
                templateUrl: '/templates/pages/administration/team-actions.html',
                controller: 'AdministrationTeamActionsController',
                controllerAs: 'vm',
                params: {
                    parent: 'administration',
                    htmlTitle: 'Administration',
                    pageTitle: 'Administration'
                }
            })
            .when('/administration/admin-accounts', {
                templateUrl: '/templates/pages/administration/admin-accounts.html',
                controller: 'AdministrationAccountsController',
                controllerAs: 'vm',
                params: {
                    parent: 'administration',
                    htmlTitle: 'Administration',
                    pageTitle: 'Administration'
                }
            })
            .when('/administration/team-actions/:accountId', { // add : accountId
                templateUrl: '/templates/pages/administration/team-actions-details.html',
                controller: 'AdministrationTeamDetailsController',
                controllerAs: 'vm',
                params: {
                    parent: 'administration',
                    htmlTitle: 'Administration',
                    pageTitle: 'Administration'
                }
            });

        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false
        });
    }

})();


// WEBPACK FOOTER //
// ./js/urls/administration.js